"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedbackPrompt = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var __1 = require("../..");
var analytics_subjects_1 = require("../../analytics-subjects");
var config_1 = require("../../config");
var internal_tracker_1 = require("../../internal-tracker");
var FeedbackPrompt_styled_1 = require("./FeedbackPrompt.styled");
var StarButton_1 = require("./StarButton");
var copy_1 = require("./copy");
var utils_1 = require("./utils");
var FeedbackPrompt = function (_a) {
    var _b;
    var id = _a.id, label = _a.label, _c = _a.probability, probability = _c === void 0 ? 100 : _c, rest = __rest(_a, ["id", "label", "probability"]);
    var _d = __read((0, react_1.useState)(0), 2), submitted = _d[0], setSubmitted = _d[1];
    var Copy = (0, __1.useCopy)(copy_1.defaultOptions).Copy;
    var feedbackPrompt = config_1.configService.getConfig().feedbackPrompt;
    var probabilityFlag = (0, react_1.useMemo)(function () { return (0, utils_1.probabilityResult)(probability); }, [
        probability,
    ]);
    if (feedbackPrompt === false || !probabilityFlag) {
        return null;
    }
    return (react_1.default.createElement(ui_tools_1.AnalyticsView, { name: analytics_subjects_1.FEEDBACK_PROMPT, properties: (_b = {},
            _b[internal_tracker_1.INTERNAL_EVENT_FLAG] = true,
            _b.id = id,
            _b) },
        react_1.default.createElement("div", __assign({}, rest),
            react_1.default.createElement(FeedbackPrompt_styled_1.StyledLabel, null, label),
            react_1.default.createElement("div", { "aria-live": "polite" }, submitted ? react_1.default.createElement(Copy, { copyKey: "feedbackPromptSuccessMessage" }) : null),
            submitted === 0 ? (react_1.default.createElement(FeedbackPrompt_styled_1.StyledStars, null, [5, 4, 3, 2, 1].map(function (value) {
                var _a;
                return (react_1.default.createElement(ui_tools_1.AnalyticsClick, { key: value, name: analytics_subjects_1.FEEDBACK_PROMPT_RATING, properties: (_a = {},
                        _a[internal_tracker_1.INTERNAL_EVENT_FLAG] = true,
                        _a.id = id,
                        _a.value = value,
                        _a.type = 'stars',
                        _a) },
                    react_1.default.createElement(StarButton_1.StarButton, { rating: value, "data-rating": value, onClick: function () { return setSubmitted(value); } })));
            }))) : null)));
};
exports.FeedbackPrompt = FeedbackPrompt;
